export const tooManyEditTemplatesError = (apiVersion: string) =>
  `Too many EditTemplate entities with the same apiVersion (${apiVersion}) associated with this entity. Only one per apiVersion is allowed. Go to the template page to see which edit templates are associated with this entity.`;
export const NO_EDIT_TEMPLATE_FOUND_ERROR =
  'Editor Wizard is not available on this entity. Ask the Platform Team to define an edit template.';
export const NO_REVERSE_PROVISIONING_TEMPLATE_FOUND_ERROR =
  'Reverse Provisioning is not available on this entity. Ask the Platform Team to define a reverse provisioning template.';
